/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:31
 * @LastEditors: yy
 * @LastEditTime: 2020-08-13 14:05:49
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './CustomLayout.css';
import Link from '../Link/Link';

// import HeaderPlus from '../HeaderPlus/HeaderPlus';


class CustomLayout extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      links: this.props.links || [],
      show: true
    }
  }

  toggle = () => {
    this.setState({
      show: !this.state.show
    })
  }

  render () {
    const {links, show} = this.state;
    const header = this.props.header
    return (
      <div className={s.container}>
        {/* <HeaderPlus /> */}

        <div className={s.viewWrapper}>

          <div className={[s.toolView, !show ? s.toolViewHide : ''].join(' ')}>
            <button
              className={s.toggleButton}
              onClick={this.toggle}
            > {show ? '<<' : '>>'} </button>

            <h1 className={s.pageTitle}><Link to="/">数字品牌榜</Link></h1>
            <h1 className={s.pageTitle}>常用图表</h1>

            {header && <div className={s.pageWrapper}>{header()}</div>}

            {(links && links.length>0) && <div className={s.pageWrapper}>
              {links.map(item => {
                if (typeof item === 'string') {
                  return <Link to={`/customChart/${item}`} key={item}>{item}</Link>
                }
                return <Link to={`/customChart/${item.url}`} key={item.url}>{item.name}</Link>
              })}
            </div>}
          </div>

          <div className={s.mainWrapper}>
            <div className={s.pageView}>
              {this.props.children}
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default withStyles(s)(CustomLayout);


// WEBPACK FOOTER //
// src/components/CustomLayout/CustomLayout.js